import { useEffect, useState } from "react";
import styles from "./Invitations.module.css";
import { LanguageContext } from "../../context/LanguageContext";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import getInvites from "../../store/family/getInvites/GetInvites";
import { getInvitesAction } from "../../store/family/getInvites/GetInvitesSlice";
import Loader from "../../components/spinner/Loader";
import ConfirmationModal from "../../components/modal/confirmationModal/ConfirmationModal";
import acceptDeclineInvite from "../../store/family/acceptDeclineInvite/AcceptDeclineInvite";
import FamilyInviteModal from "../../components/modal/familyInviteModal/FamilyInviteModal";
import { acceptDeclineInviteAction } from "../../store/family/acceptDeclineInvite/AcceptDeclineInviteSlice";
import { useNavigate } from "react-router-dom";
import { InvitationCard } from "./InvitationCard";

export default function FamilyInvitations() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedInvite, setSelectedInvite] = useState(null);
  const [invitations, setInvitations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [action, setAction] = useState({ type: "", id: "" });
  const getInvitesData = useSelector((state) => state.getInvites);
  const acceptDeclineInviteData = useSelector((state) => state.acceptDeclineInvite);
  const token = Cookies.get("auth_token");

  useEffect(() => {
    if (token) {
      dispatch(getInvites(token))
    }
  }, [dispatch, token]);

  useEffect(() => {
    if (getInvitesData?.status === "succeeded") {
      setInvitations(getInvitesData.data)
      setLoading(false)
      dispatch(getInvitesAction.getInvitesReset());
    } else if (getInvitesData?.status === "failed") {
      dispatch(getInvitesAction.getInvitesReset());
      setLoading(false)
      setInvitations([])
    }
  }, [dispatch, getInvitesData, token])

  useEffect(() => {
    if (acceptDeclineInviteData?.status === "succeeded") {
      setLoading(false)
      if (action.type === "decline") {
        setInvitations((prev) => prev.filter((inv) => inv._id !== selectedInvite?._id));
        setSelectedInvite(null)
        setModal(null)
        setAction({ type: "", id: "" })
      }
      dispatch(acceptDeclineInviteAction.acceptDeclineInviteReset());
    } else if (acceptDeclineInviteData?.status === "failed") {
      setAction({ type: "", id: "" })
      setLoading(false)
      dispatch(acceptDeclineInviteAction.acceptDeclineInviteReset());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, acceptDeclineInviteData, action]);

  const handleAccept = (invitation) => {
    setModal("accept")
    setSelectedInvite(invitation);
  };

  const handleDecline = (invitation) => {
    setModal("decline")
    setSelectedInvite(invitation);
  };

  const handleReject = () => {
    if (!selectedInvite) return;
    setAction({ type: "decline", id: selectedInvite?._id })
    dispatch(acceptDeclineInvite(token, selectedInvite?._id, "decline"))
  };

  const handleClose = () => {
    setSelectedInvite(null);
    setModal(null)
  };

  return (
    <LanguageContext.Consumer>
      {({ data, language: lang }) => {
        const t = (key) => data?.[key]?.[lang];

        return (
          <>
            <div className={styles.page}>
              <div className={styles.container}>
                <header className={styles.header}>
                  <button className={styles.backBtn} aria-label="Go back" onClick={() => navigate(-1)}>
                    <img src="/assets/subscriptions/back.svg" alt="" width={22} height={22} />
                  </button>
                  <div>
                    <h1 className={styles.title}>{t("family_invitations")}</h1>
                    <p className={styles.subtitle}>{t("family_invitations_description")}</p>
                  </div>
                </header>
                {loading ? (
                  <Loader />
                ) : (      
                  invitations.length === 0 ? (
                    <div className={styles.empty}>
                      <div className={styles.emptyIllustration}>
                        <div className={styles.vinniWrap}>
                          <img src="/assets/icons/vinni.svg" alt="" className={styles.vinniImg}/>
                        </div>
                      </div>
                      <h3 className={styles.emptyTitle}>{t("no_invitations_found")}</h3>
                      <p className={styles.emptySubtitle}>
                       {t("no_family_invitations_desc_line1")}<br />{t("no_family_invitations_desc_line2")}
                      </p>
                    </div>
                  ) : (
                    <div className={styles.cards}>
                      {invitations.map((invitation) => (
                        <InvitationCard key={invitation.id} {...{ invitation, t, handleAccept, handleDecline }} />
                      ))}
                    </div>
                  )
                )}
              </div>
            </div>
            {selectedInvite && modal === "accept" && (
              <FamilyInviteModal onClose={handleClose} getInvitesData={selectedInvite ? [selectedInvite] : []} allowReject={false}/>
            )}
            {selectedInvite && modal === "decline" &&  (
              <ConfirmationModal
                show={modal === "decline" && selectedInvite}
                onHide={handleClose}
                logOutHandler={handleReject}
                titles={{
                  max_title: t("reject_invitation_title"),
                  mid_title: t("reject_invitation_subtitle")
                }}
              />
            )}
          </>
        );
      }}
    </LanguageContext.Consumer>
  );
}